import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, input, signal } from "@angular/core";
import {
  IonicModule,
  isPlatform,
  ModalController,
} from "@ionic/angular";
import { Store } from "@ngrx/store";
import { selectAllProducts } from "../../ngrx/products.selectors";
import { deleteProduct, loadProducts } from "../../ngrx/products.actions";
import { ProductDto } from "../../interfaces/product_dto";
import { NoSelectionComponent } from "src/app/shared/components/no-selection/no-selection.component";
import { ProductFormComponent } from "../../components/product-form/product-form.component";
import { DialogService } from "src/app/shared/services/dialog.service";

@Component({
    selector: "app-product-list",
    templateUrl: "./product-list.component.html",
    styleUrls: ["./product-list.component.scss"],
    imports: [IonicModule, CommonModule, NoSelectionComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListComponent {
  readonly isSelection = input<boolean>(false);
  originPage = isPlatform("ios") ? "Einstellungen" : "";
  productsSignal = this.store.selectSignal(selectAllProducts);
  isSharePluginAvailable: boolean;

  constructor(
    private store: Store<any>,
    private modalController: ModalController,
    private dialogService: DialogService
  ) {
  }

  ngOnInit() {
    this.store.dispatch(loadProducts());
  }

  async productClicked(product: ProductDto) {
    if (await this.modalController.getTop() && this.isSelection()) {
      // If modal is open and in selection mode, return product
      this.modalController.dismiss(product);
    } else {
      // Otherwise open edit form
      this.openProductForm(product);
    }
  }

  async openProductForm(product?: ProductDto) {
    const modal = await this.modalController.create({
      component: ProductFormComponent,
      componentProps: {
        product: signal(product),
      },
    });
    return modal.present();
  }

  async deleteProduct(event: Event, product: ProductDto) {
    event.stopPropagation(); // Prevent opening edit form
    this.store.dispatch(deleteProduct({ productId: product.product_id }));
  }
}

